export default __webpack_public_path__ + "static/char-s-46-ko-5cf455bebfbf0f75935013bb5028ea56.webp";